import { useSelector } from 'react-redux';
import { RootState } from '@/shared/store/store';

export const useApiState = (key: string) => {
    const loading = useSelector((state: RootState) => state.general.loadingMap[key] || false);
    const error = useSelector((state: RootState) => state.general.errorMap[key] || null);
    return { loading, error };
};
